<template>
    <FactureCard>
      <template v-slot:title>Détails de la facture</template>
      <v-data-table  light 
          hide-default-footer
          disable-sort
          disable-filtering
          :headers="headers"
          :items="detailsPretty"
          dense
          >
          <template v-slot:body.append="{headers}">
            <tr><td colspan="4"></td></tr>
            <SousTotalRow title="Total avant taxes" :montant="formatPrix(facture.montantHT)"></SousTotalRow>
            <SousTotalRow v-if="facture.rabais > 0" title="Rabais" :montant="formatPrix(facture.rabais)"></SousTotalRow>
            <SousTotalRow v-for="taxe in facture.taxes"
                          :key="taxe.code"
                          :title="taxe.code"
                          :montant="formatPrix(taxe.montant)"></SousTotalRow>
            <SousTotalRow title="Total" :montant="formatPrix(facture.total)"></SousTotalRow>
            <SousTotalRow title="Déjà payé" :montant="formatPrix(facture.dejaPaye)"></SousTotalRow>
            <SousTotalRow title="Solde" :montant="formatPrix(facture.solde)"></SousTotalRow>
          </template>
        </v-data-table>
    </FactureCard>
</template>

<script>
import FactureCard from "./FactureCard"
import SousTotalRow from "./SousTotalRow"

    export default {
      components:{FactureCard, SousTotalRow},
        name: 'facture',
        props: ['facture', "formatPrix", "formatQuantite"],
        data() {
            return {
                headers: [
                    {  text: 'Description', align: 'left', sortable: false, value: 'libelle' },
                    {  text: 'Prix Unitaire', align: 'right', sortable: false, value: 'prixUnitaire' },
                    {  text: 'Quantité', align: 'right', sortable: false, value: 'quantite' },
                    {  text: 'Prix', value: 'prix', align: "right", sortable: false }
                ]

            }
        },
        computed: {
            detailsPretty() {
                let result = this.facture.details.map(detail => {
                    return {
                      libelle: detail.libelle.replace(/\<br\/\>/g, ""),
                      prixUnitaire: this.formatPrix(detail.prixUnitaire),
                      quantite: this.formatQuantite(detail.quantite),
                      prix: this.formatPrix(detail.prixTotal)
                    }
                })
                return result;
            }
        }
    };
</script>

<style scoped>
</style>
